import { Navigate, Outlet, useLocation } from "react-router";
import { AUTH_ROUTES } from "@/src/auth/constants/auth-routes";
import { getIsAuthenticated, getIsProfileComplete } from "@/src/auth/store/auth-selectors";
import { getSubdomain } from "@/src/common/lib/subdomain";
import { useAppSelector } from "@/src/common/redux/store";
import { getCommunities } from "@/src/community/store/community-selectors";
import { ONBOARDING_ROUTES } from "@/src/onboarding/constants/onboarding-routes";

export function OnboardingRouteLayout() {
	const isAuthenticated = useAppSelector(getIsAuthenticated);
	const isProfileComplete = useAppSelector(getIsProfileComplete);
	const communities = useAppSelector(getCommunities);
	const { pathname } = useLocation();
	const subdomain = getSubdomain();

	if (!isAuthenticated) {
		return <Navigate to={AUTH_ROUTES.AUTH} replace />;
	}

	if (pathname === ONBOARDING_ROUTES.ROOT) {
		if (!isProfileComplete) {
			return <Navigate to={ONBOARDING_ROUTES.PROFILE} replace />;
		}

		if (subdomain) {
			return <Navigate to={ONBOARDING_ROUTES.JOIN_COMMUNITY} replace />;
		}

		if (communities.length === 0) {
			return <Navigate to={ONBOARDING_ROUTES.CREATE_COMMUNITY_PROFILE} replace />;
		}

		return <Navigate to={ONBOARDING_ROUTES.SELECT_COMMUNITY} replace />;
	}

	return <Outlet />;
}
